import * as React from "react";
import { useState, useEffect, useRef } from "react";
import esercizi from '../assets/icons/esercizi.svg';
import phone from '../assets/icons/phone.svg';
import alert from '../assets/icons/alert.svg';
import cerchioPiu from '../assets/icons/cerchioPiu.svg';
import ButtonCreaNuovo from "../components/ButtonCreaNuovo";
import FilterBar from "../components/FilterBar";
import MiniCard from "../components/MiniCard";
import ODMTable from "../components/ODMTable";
import { useNavigate } from "react-router-dom";
import { Alert, Box, Drawer, Snackbar } from '@mui/material';
import { Align, THead, tooltipColumnIds } from "../interfaces/Esercizio"
import { Spinner } from "react-bootstrap";
import SpinnerODM from "../components/spinnerODM";
import EditActivitiesFast from "../components/EditActivitiesFast";
import { fetchBE } from "../utils/utils";
import NewActivitiesFast from "../components/NewActivitiesFast";
import { FilterType } from "../utils/filters"

//interface ListaEserciziProps {
//  token: string;
//}

//const ListaEsercizi: React.FC<ListaEserciziProps> = ({ token }) => {
const ListaEsercizi: React.FC = () => {
  const [activities, setActivities] = useState<any[]>([]);
  const [filteredActivities, setFilteredActivities] = useState<any[]>([]);
  const [filters, setFilters] = useState<Record<string, (string | number)[]>>({});
  const [searchTerm, setSearchTerm] = useState('');
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const [refresh, setRefresh] = useState<number>(0);
  const [generatedFilters, setGeneratedFilters] = useState<FilterType[]>([]);
  const [editingActivityId, setEditingActivityId] = useState<number | null | undefined>(undefined);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState<{ icon: React.ReactNode | null; message: string }>({ icon: null, message: '', });
  const navigate = useNavigate();
  const [showNewActivitiesFast, setShowNewActivitiesFast] = useState(false);
  const [typeActivities, setTypeActivities] = useState<string | null>(null);
  const [editNewType, setEditNewType] = useState<string | null>(null);
  const [newExerciseType, setNewExerciseType] = useState<string | null>(null);
  const [positionOn, setPositionOn] = useState<number>(0);
  const [editActivitiesFastKey, setEditActivitiesFastKey] = useState(0);

  const fetchActivities = async () => {
    setLoading(true);
    try {
      //console.profile("fetchActivities");
      const [data, error] = await fetchBE('/api/v0/activities')
      if (data) {
        data.forEach((e: any) => {
          if (e.equipment.length==0) (e.equipment as any).push("Solo carico naturale");
        });
        setGeneratedFilters(generateFiltersFromData(data));
        setActivities(data);
        //setFilteredActivities(data);
      } else if (error) {
        if (error.message) {
          setError(error.message);
        }
      }
    } finally {
      //console.profileEnd("fetchActivities");
      setLoading(false);
    }

  };

  const solocariconaturale = 'Solo carico naturale';
  const generateFiltersFromData = (data: any[]) => {
    const filtersObject: FilterType[] = [
      { key: "mode", name: "Modalità", subFilters: [] },
      { key: "purpose", name: "Finalità", subFilters: [] },
      { key: "muscle_groups", name: "Comparto", subFilters: [] },
      { key: "posture", name: "Assetto", subFilters: [] },
      { key: "complex_function", name: "Funzione complessa", subFilters: [] },
      { key: "equipment", name: "Attrezzo", subFilters: [solocariconaturale] },
      { key: "recommended_for", name: "Raccomandato per", subFilters: [] },
      { key: "contraindicated_for", name: "Controindicato per", subFilters: [] },
      { key: "gravity_management_complexity", name: "Complessità gestione gravitaria", subFilters: [] },
      { key: "motor_coordination_complexity", name: "Complessità coordinazione motoria", subFilters: [] },
      { key: "cardiorespiratory_complexity", name: "Intensità cardio-respiratoria", subFilters: [] },
      { key: "status", name: "Stato", subFilters: [] },
    ];

    data.forEach(item => {
      filtersObject.forEach(obj => {
        const value = item[obj.key];
        if (
          value &&
          !(obj.key=='status' && value=='Publishable')
          ) {
          if (Array.isArray(value)) {
            value.forEach((v) => {
              if (!obj.subFilters.includes(v)) obj.subFilters.push(v);
            });
          } else {
            if (!obj.subFilters.includes(value)) obj.subFilters.push(value);
          }
          if(obj.subFilters.length>0){
              if(typeof obj.subFilters[0] === "string"){
              obj.subFilters = [...obj.subFilters].sort((a, b) => (a as string).localeCompare((b as string)))
            } else if (typeof obj.subFilters[0] === "number"){
              obj.subFilters = [...obj.subFilters].sort((a, b) => (a as number) - (b as number))
            }
          }
        }
      });
    });

    return filtersObject;
  };

  useEffect(() => {
    if (newExerciseType) {
      setEditingActivityId(null);
    }
  }, [newExerciseType]);

  useEffect(() => {
    fetchActivities();
  }, [refresh]);

  useEffect(() => {
    if (typeActivities) {
      setEditNewType(typeActivities);
      setTypeActivities(null);
      setShowNewActivitiesFast(false);
    }
  }, [typeActivities]);

  useEffect(() => {
    let updated = [...activities];

    if (searchTerm.trim()) {
      updated = updated.filter((activity) =>
        activity.full_name?.toLowerCase().includes(searchTerm.toLowerCase())
        ||
        activity.position?.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }

    Object.entries(filters).forEach(([key, values]) => {
      if (values.length > 0) {
        updated = updated.filter((activity) => {
          let activityKeyValues = null
          if (Array.isArray(activity[key])) {
            activityKeyValues = [...activity[key]];
          } else {
            activityKeyValues = activity[key];
          }

          if(key=='equipment' && values.includes(solocariconaturale) && activityKeyValues.length==0){
            activityKeyValues.push(solocariconaturale);
          }
          return (
            (Array.isArray(activityKeyValues) && values.some(v => activityKeyValues.includes(v)))
            ||
            values.includes(activityKeyValues)
          )
        });
      }
    });

    setFilteredActivities(updated);
  }, [activities, filters, searchTerm]);

  if (error) return <div>Errore: {error}</div>;

  const publishedCount = filteredActivities.filter((item) => item.status == "Pubblicato").length;
  const draftCount = filteredActivities.filter((item) => item.status == "Non Pubblicabile").length;

  return (
    <>
      {loading ? (<SpinnerODM />) : ""}
      <Box sx={{ display: "flex", height: "100%", width: "100%" }}>
        <Box
          component="section"
          sx={{
            flexGrow: 1,
            height: "100%",
            transition: 'margin 0.3s ease',
            width: "100%",
            overflowY: 'hidden',
            overflowX: 'auto'
          }}
        >
          <div className="p-3 backgroundPage" style={{ height: "100%", width: "100%" }}>
            <div className="row">
              <div className="col">
                <h1>Lista Esercizi</h1>
                <p>Crea nuovi esercizi o modifica quelli già presenti</p>
              </div>

              <div className="col-8 text-end">
                <div className="d-flex flex-wrap justify-content-end gap-3 mb-4 text-start">
                  <ButtonCreaNuovo
                    onClick={() => {
                      //setShowNewActivitiesFast(true)
                      setEditActivitiesFastKey(k => k + 1);
                      setEditingActivityId(undefined);
                      setNewExerciseType("Exercise");
                    }}
                    title="Crea nuovo"
                    icon={<img src={cerchioPiu} alt="icon" width={30} />}
                  />
                  <MiniCard
                    name="Esercizi"
                    value={filteredActivities.length}
                    icon={<img src={esercizi} alt="icon" width={30} />}
                  />
                  <MiniCard
                    name="Pubblicati"
                    value={publishedCount}
                    icon={<img src={phone} alt="icon" width={30} />}
                  />
                  <MiniCard
                    name="Incompleti"
                    value={draftCount}
                    icon={<img src={alert} alt="icon" width={30} />}
                    color={draftCount === 0 ? "" : "#d54a4a"}
                  />
                </div>
              </div>
            </div>

            <Box
              component="section"
              sx={{
                flexGrow: 1,
                display: "flex",
                flexDirection: "row",
                height: "100%",
                width: "100%",
                overflow: "hidden",
                paddingBottom: 17
              }}
            >
              <Box sx={{ maxWidth: 400, flexShrink: 0 }}>
                <FilterBar
                  filters={generatedFilters}
                  onFilterChange={setFilters}
                  onSearchChange={setSearchTerm}
                />
              </Box>
              <Box
                component="section"
                sx={{
                  flexGrow: 1,
                  overflow: "hidden",
                  marginLeft: "20px",
                  height: "100%",
                  width: "100%",
                }}
              >

                <ODMTable
                  columns={THead}
                  rows={filteredActivities}
                  navTable="esercizi"
                  onRowClick={(row, positionOn) => {
                    if(positionOn) setPositionOn(positionOn)
                    setEditingActivityId(row.id);
                    setShowNewActivitiesFast(false);
                  }}
                  selectedRowId={editingActivityId ?? undefined}
                  stickyColumnIds={["position", "full_name",]}
                  edit={true}
                  tooltipColumnIds={tooltipColumnIds}
                  positionOn={positionOn}
                />
              </Box>
            </Box>
          </div>
        </Box>
        <Box sx={{ maxWidth: 500, position: 'flex', height: "80vh" }}>
          {(editingActivityId !== undefined || newExerciseType !== null) && (
            <EditActivitiesFast
              key={"EditActivitiesFastKey-" + editActivitiesFastKey}
              activity={editingActivityId ?? null}
              open={!showNewActivitiesFast}
              onClose={() => {
                setEditingActivityId(undefined);
                setNewExerciseType(null);
              }}
              refreshActivities={() => setRefresh(refresh + 1)}
              defaultType={newExerciseType ?? undefined}
              setSnackbarOpen={setSnackbarOpen}
              setSnackbarMessage={setSnackbarMessage}
            />
          )}
        </Box>
        {/*<Box sx={{ maxWidth: 500, position: 'flex', height: "100%" }}>
          {showNewActivitiesFast && (
            <NewActivitiesFast
              open={showNewActivitiesFast}
              onClose={() => setShowNewActivitiesFast(false)}
              setTypeActivities={(type) => {
                setShowNewActivitiesFast(false);
                setNewExerciseType(type);
              }}
            />
          )}
        </Box>*/}
      </Box>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={3000}
        onClose={() => setSnackbarOpen(false)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert
          onClose={() => setSnackbarOpen(false)}
          sx={{ width: '100%', backgroundColor: "black", color: "white", borderRadius: 3 }}
          icon={snackbarMessage.icon}
        >
          {snackbarMessage.message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default ListaEsercizi;